import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { InspectionCertificate, InspectionReport } from '../../../../../constants/DocumentTypes';
import HistoryEventTypes from '../../../../../constants/HistoryEventTypes';
import { DoorHistoryFragment } from '../../../../../queries';
import DocumentRow from '../../../../DocumentRow';
import DoorHistoryDetailDialog from '../DoorHistoryDetailDialog';
import StandardGridItem from './StandardGridItem';

interface FailureRisk {
  id: number;
  name: string;
}

interface DoorInspectionAdditionalInfo {
  message?: string;
  inspectedBy: string;
  inspectionCheckedBy: string;
  inspectionId: number;
  site: string;
  location: string;
  locationType?: string;
  reportId?: number;
  reportOriginalFilename: string;
  certificateId?: number;
  certificateOriginalFilename: string;
  failureRisk?: FailureRisk;
  canBeRepaired?: boolean;
}

interface DoorInspectionDetailDialogProps {
  open: boolean;
  onClose: () => void;
  history: DoorHistoryFragment;
}

interface DetailDialogProps {
  history: DoorHistoryFragment;
  isPass: boolean;
}

function DetailDialog({ history, isPass }: DetailDialogProps) {
  if (!history.additionalInfoJson) {
    return <></>;
  }

  const additionalInfo = JSON.parse(history.additionalInfoJson) as DoorInspectionAdditionalInfo;
  return (
    <Box pt={1} pb={1}>
      <Grid container spacing={3}>
        <StandardGridItem title="Site" value={additionalInfo.site} />
        <StandardGridItem title="Location" value={additionalInfo.location} />
        <StandardGridItem title="Inspected by" value={additionalInfo.inspectedBy} />
        {additionalInfo.locationType && <StandardGridItem title="Location type" value={additionalInfo.locationType} />}

        {additionalInfo.failureRisk && (
          <StandardGridItem title="Failure risk" value={additionalInfo.failureRisk.name} />
        )}

        {additionalInfo.canBeRepaired !== undefined && (
          <StandardGridItem title="Can be repaired" value={additionalInfo.canBeRepaired ? 'Yes' : 'No'} />
        )}

        <StandardGridItem
          title={isPass ? 'Signoff comment' : 'Failure reason'}
          value={additionalInfo.message}
          minWidth={12}
        />
        {additionalInfo.reportId && (
          <DocumentRow
            originalFilename={additionalInfo.reportOriginalFilename}
            documentType={{ code: InspectionReport, name: 'Inspection report' }}
            documentId={additionalInfo.reportId}
          />
        )}
        {additionalInfo.certificateId && (
          <DocumentRow
            originalFilename={additionalInfo.certificateOriginalFilename}
            documentType={{ code: InspectionCertificate, name: 'Inspection certificate' }}
            documentId={additionalInfo.certificateId}
          />
        )}
      </Grid>
    </Box>
  );
}

export default function DoorInspectionDetailDialog({ open, onClose, history }: DoorInspectionDetailDialogProps) {
  const isPass = history.historyEventType.code === HistoryEventTypes.DoorInspectionPassed;
  const actorName = isPass ? 'Signed off' : 'Failed by';
  return (
    <DoorHistoryDetailDialog open={open} onClose={onClose} history={history} actorName={actorName}>
      <DetailDialog history={history} isPass={isPass} />
    </DoorHistoryDetailDialog>
  );
}
